"use strict";

var ADX_TOKEN_MULTIPLIER = 10000;
var ADX_TOKEN_PRECISION = 4;
module.exports = {
  ADX_TOKEN_MULTIPLIER: ADX_TOKEN_MULTIPLIER,
  ADX_TOKEN_PRECISION: ADX_TOKEN_PRECISION
};